import { createContext, useContext } from "react";
import { type FeatureFlagsValue } from "./types";
import { DEFAULT_FEATURE_FLAGS_VALUES } from "./utils";

export const FeatureFlagsContext = createContext<FeatureFlagsValue>(DEFAULT_FEATURE_FLAGS_VALUES);

export function useFeatureFlagsContext() {
	const context = useContext(FeatureFlagsContext);

	if (!context) {
		throw new Error("useFeatureFlagsContext must be used within a FeatureFlagsContext");
	}

	return context;
}
